import {
  EditBlockColorPicker,
  EditBlockSelect,
  EditBlockTextInput,
  EditBlockNumericInput,
  EditBlockSliderInput,
  EditBlockSwitch,
} from '@components/EditBuildingBlocks/all'
import genericContentItemEditor from '@components/mixins/genericContentItemEditor'
import { mapGetters } from 'vuex'

export default {
  name: 'ButtonEditorComponent',
  mixins: [genericContentItemEditor],
  components: {
    'edit-block-color-picker': EditBlockColorPicker,
    'edit-block-select': EditBlockSelect,
    'edit-block-text-input': EditBlockTextInput,
    'edit-block-numeric-input': EditBlockNumericInput,
    'edit-block-slider-input': EditBlockSliderInput,
    'edit-block-switch': EditBlockSwitch,
  },
  data() {
    return {}
  },
  computed: {
    targetStepID() {
      return this.$store.state.campaign.step.targetStepID
    },
    ...mapGetters('campaign/widget', ['targetWidgetStepsList']),
    widgetStepsList() {
      return this.targetWidgetStepsList.map((item, index) => {
        const isCurrent = this.targetStepID === item
        const label = isCurrent ? index + 1 + ' (current)' : index + 1 + ''
        return { label: label, value: item, disabled: isCurrent }
      })
    },
    buttonText: {
      get() {
        return this.component.content.text
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['content'],
          attribute: ['text'],
          data: value,
        })
      },
    },
    //= ==============STYLING
    buttonFontFamily: {
      get() {
        return this.component.styling.fontFamily
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontFamily'],
          data: value,
        })
      },
    },
    buttonFontColor: {
      get() {
        return this.component.styling.color
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['color'],
          data: value,
        })
      },
    },
    buttonBackgroundColor: {
      get() {
        return this.component.styling.backgroundColor
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['backgroundColor'],
          data: value,
        })
      },
    },
    buttonBorderWidth: {
      get() {
        // Removes 'px' from string
        return parseInt(this.component.styling.borderWidth, 10)
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderWidth'],
          data: value + 'px',
        })
      },
    },
    buttonBorderRadius: {
      get() {
        return parseInt(this.component.styling.borderRadius, 10)
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderRadius'],
          data: value + 'px',
        })
      },
    },
    buttonBorderColor: {
      get() {
        return this.component.styling.borderColor
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['borderColor'],
          data: value,
        })
      },
    },
    buttonFontSize: {
      get() {
        return this.component.styling.fontSize
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['fontSize'],
          data: value,
        })
      },
    },
    buttonAlign: {
      get() {
        return this.component.styling.justifyContent
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['styling'],
          attribute: ['justifyContent'],
          data: value,
        })
      },
    },
    //= ==============SETTINGS
    buttonAction: {
      get() {
        return this.component.settings.action
      },
      set(value) {
        if (value === 'jump' || value === 'url' || value === 'email') {
          this.buttonHref = ''
        }

        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['action'],
          data: value,
        })
      },
    },
    buttonHref: {
      get() {
        return this.component.settings.href
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['href'],
          data: value,
        })
      },
    },
    backBtn: {
      get() {
        return this.component.settings.backBtn
      },
      set(value) {
        this.updateContentItem({
          id: this.component.id,
          path: ['settings'],
          attribute: ['backBtn'],
          data: value,
        })
      },
    },
  },
}
